import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import PageMeta from "@/components/base/PageMeta";

const siteUrl = import.meta.env.VITE_PUBLIC_SITE_URL || "https://hackerslodge.com";

export default function ServerError() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#0d1117] flex items-center justify-center px-4">
      <PageMeta
        title="500 — Internal Server Error"
        description="Something went wrong on our end. Our team has been notified and is working to fix the issue. Please try again in a few minutes."
        canonicalUrl={`${siteUrl}/500`}
        noindex={true}
      />
      <div className="text-center max-w-md">
        <h1 className="text-8xl md:text-9xl font-black text-red-500/20 select-none mb-4">
          500
        </h1>
        <h2 className="text-xl md:text-2xl font-semibold text-gray-200 mb-2">
          Internal Server Error
        </h2>
        <p className="text-sm text-gray-500 mb-6 leading-relaxed">
          Something went wrong on our end. Our team has been notified and is working to fix the issue. Please try again in a few minutes.
        </p>
        {location.pathname && (
          <p className="text-xs text-gray-600 font-mono mb-6">
            Error occurred at: {location.pathname}
          </p>
        )}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center gap-2 bg-[#5bc0de] hover:bg-[#46b8da] text-white text-sm font-semibold px-6 py-2.5 rounded transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="fas fa-redo mr-1" /> Try Again
          </button>
          <Link
            to="/"
            className="inline-flex items-center gap-2 border border-gray-600 hover:bg-[#161b22] text-gray-300 text-sm font-semibold px-6 py-2.5 rounded transition-all whitespace-nowrap"
          >
            <i className="fas fa-home mr-1" /> Back to Home
          </Link>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-800">
          <p className="text-xs text-gray-500">
            Need help?{" "}
            <Link to="/contact" className="text-[#5bc0de] hover:text-[#46b8da] font-semibold">
              Contact Support
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}